import type { ComponentProps, FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { CountryChipItem, SimpleChipItem, type IChipItemProps, WebsiteChipItem } from "@similarweb/ui-components";

export const StyledSimpleChip = styled<FC<IChipItemProps>>(SimpleChipItem)`
    background: ${colorsPalettes.bluegrey[300]};
    width: fit-content;
    pointer-events: ${({ hideActionButton }) => (hideActionButton ? "none" : "auto")};

    .ChipItemText {
        color: ${colorsPalettes.carbon[500]};
    }

    &:hover {
        background: #cadbeb;
        ${SWReactIcons} {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
            }
        }
    }

    ${SWReactIcons} {
        svg path {
            fill: ${colorsPalettes.midnight[300]};
        }

        &:hover {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
            }
        }
    }
`;

export const StyledCountryChip = styled<FC<ComponentProps<typeof CountryChipItem>>>(CountryChipItem)`
    pointer-events: ${({ hideActionButton }) => (hideActionButton ? "none" : "auto")};

    &:hover {
        background: #cadbeb;
        ${SWReactIcons} {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
            }
        }
    }

    ${SWReactIcons} {
        svg path {
            fill: ${colorsPalettes.midnight[300]};
        }

        &:hover {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
            }
        }
    }
`;

export const StyledChipContainer = styled.div`
    > span {
        background: ${colorsPalettes.bluegrey[300]};
        ${mixins.setFontVariant("chip1", colorsPalettes.carbon[500])}
        width: fit-content;

        .ChipItemText {
            color: ${colorsPalettes.carbon[500]};
        }

        &:hover {
            background: #cadbeb;
            ${mixins.setFontVariant("chip1", colorsPalettes.carbon[500])}

            ${SWReactIcons} {
                svg path {
                    fill: ${colorsPalettes.midnight[400]};
                }
            }
        }

        ${SWReactIcons} {
            &.chipsItemRegion {
                svg path {
                    fill: #b0bac8;
                }
            }
            svg path {
                fill: ${colorsPalettes.midnight[400]};
            }

            &:hover {
                svg path {
                    fill: ${colorsPalettes.midnight[400]};
                }
            }
        }
    }
`;

export const StyledWebsiteChip = styled<FC<IChipItemProps>>(WebsiteChipItem)`
    background: ${colorsPalettes.bluegrey[300]};
    width: fit-content;
    pointer-events: ${({ hideActionButton }) => (hideActionButton ? "none" : "auto")};
    height: 24px;

    .ChipItemText {
        color: ${colorsPalettes.carbon[500]};
    }

    & > span:has(img) {
        border-radius: 50%;
        width: 22px;
        height: 22px;
    }

    &:hover {
        background: #cadbeb;
        ${SWReactIcons} {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
            }
        }
    }

    ${SWReactIcons} {
        svg path {
            fill: ${colorsPalettes.midnight[300]};
        }

        &:hover {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
            }
        }
    }
`;
